module.exports = __webpack_public_path__ + "img/08-30-170.557e29e0.jpg";